export function projectLeadReengagementFields(record = {}) {
  const history = record.lead_reengagement_history;
  return {
    lead_reengaged: record.lead_reengaged === true,
    lead_reengaged_at: record.lead_reengaged_at || null,
    lead_reengagement_event_id: record.lead_reengagement_event_id || null,
    lead_reengagement_history: history && typeof history === "object" && !Array.isArray(history)
      ? history
      : {},
  };
}